<template>
    <div
        class="skip-payment-container d-flex flex-column align-items-center justify-content-center"
    >
        <div>
            <p class="skip-payment-title">HOLD UP, think twice!</p>
            <p class="skip-payment-description">
                By not starting your free trial, you're missing out on some serious perks! No
                Booking Manager, no direct artist invites, no promotion tools and so much more.
            </p>
        </div>
        <div>
            <button class="subscribe-btn">nah, let’s do the free trial</button>
            <p class="skip-btn">sure, i’ll take the basic version for now</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SkipModalContent',
        props: {
            mode: {
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .skip-payment-container {
        min-height: 630px;
    }
    .skip-payment-title {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 24px;
        letter-spacing: 3px;
        text-transform: uppercase;
        color: #ffffff;
        margin-bottom: 45px;
        text-align: center;
    }
    .skip-payment-description {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 34px;
        text-align: center;
        color: #ffffff;
        max-width: 500px;
        margin-bottom: 80px;
    }
    .subscribe-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 20px;
        gap: 10px;
        min-width: 460px;
        background: #d7eb5a;
        border-radius: 100px;
        border: 0px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #1b0d29;
    }
    .skip-btn {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        color: #ffffff;
        cursor: pointer;
        margin-top: 20px;
    }
</style>
